import { BsShieldLock } from "react-icons/bs";
import { FiSend } from "react-icons/fi";
import CreatableSelect from "react-select/creatable";
import React, { useState, useRef, useEffect, useContext } from "react";
import {
  EditIcon,
  StopIcon,
  TelegramIcon,
  LockIcon,
  TickIcon,
} from "../../components/kits/Icons";
import ColorSchema from "../kits/Color";

import { FaEdit, FaCheck } from "react-icons/fa";
import { HiOutlineBan } from "react-icons/hi";
import Select from "react-select";
import { RiFilePaperLine } from "react-icons/ri";
import { NavLink } from "react-router-dom";
import { AiOutlineDelete } from "react-icons/ai";
import Box from "../../common/Box";
import axios from "axios";
import ReactPaginate from "react-paginate";
import "./tabs.scss";
import TableBox from "./TableBox";
import { CustomTooltip } from "../kits/tooltip/CustomTooltip";
import useAxios from "../../services/useAxios.tsx";
import AuthenticationContext from "../../Authentication/AuthenticationContext.ts";

function Selector({ value, Labels, filteredUsers, type, disabled }) {
  const [Tags, setTags] = useState([]);
  const [PServices, setPServices] = useState([]);
  const [Customers, setCustomers] = useState([]);
  const { execute: Insert_Tag } = useAxios("test/Insert_Tag");
  const { execute: Insert_TagLink } = useAxios("test/Insert_TagLink");
  const { execute: Delete_TagLink } = useAxios("test/Delete_TagLink");
  const { execute: Delete_PServiceUserLink } = useAxios(
    "test/Delete_PServiceUserLink"
  );
  const { execute: Insert_PServiceUserLink } = useAxios(
    "test/Insert_PServiceUserLink"
  );
  const { execute: Insert_CustomerUserLink } = useAxios(
    "test/Insert_CustomerUserLink"
  );

  const UsersTag = (LinkedTag) => {
    LinkedTag.map((item) => {
      if (item.__isNew__) {
        let form = new FormData();
        form.append("text", `${item.label}`);
        form.append("mtm", Date.now());
        form.append("status", 1);
        Insert_Tag(form)
          .then((data) => {
            if (data.status) {
              let form = new FormData();
              form.append("TagId", `${data.result.id}`);
              form.append("type", 1);
              form.append("linkId", `${value.id}`);
              Insert_TagLink(form)
                .then((data) => {})
                .catch((error) => {
                  console.log(error);
                });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        if (!Tags.includes(item)) {
          let form = new FormData();
          form.append("TagId", `${item.value}`);
          form.append("type", 1);
          form.append("linkId", `${value.id}`);
          Insert_TagLink(form)
            .then((data) => {})
            .catch((error) => {
              console.log(error);
            });
        }
      }
    });
    Tags.map((item) => {
      if (!LinkedTag.includes(item) && !item.__isNew__) {
        let form = new FormData();
        form.append(
          "conditions",
          `TagId/=/${item.value}@@linkId/=/${value.id}@@type/=/1`
        );
        Delete_TagLink(form)
          .then((data) => {})
          .catch((error) => {
            console.log(error);
          });
      }
    });
    setTags(LinkedTag);
  };
  const UsersCustomers = (LinkedCustomer) => {
    LinkedCustomer.map((item) => {
      if (!Customers.includes(item)) {
        let form = new FormData();
        form.append("customer_id", `${item.value}`);
        form.append("user_id", `${value.id}`);
        Insert_CustomerUserLink(form)
          .then((data) => {})
          .catch((error) => {
            console.log(error);
          });
      }
    });
    Customers.map((item) => {
      if (!LinkedCustomer.includes(item)) {
        let form = new FormData();
        form.append(
          "conditions",
          `customer_id/=/${item.value}@@user_id/=/${value.id}`
        );
        Insert_CustomerUserLink(form)
          .then((data) => {})
          .catch((error) => {
            console.log(error);
          });
      }
    });
    setCustomers(LinkedCustomer);
  };
  const UsersPS = (LinkedPS) => {
    LinkedPS.map((item) => {
      if (!PServices.includes(item)) {
        let form = new FormData();
        form.append("product_service_id", `${item.value}`);
        form.append("uid", `${value.id}`);
        Insert_PServiceUserLink(form)
          .then((data) => {})
          .catch((error) => {
            console.log(error);
          });
      }
    });
    PServices.map((item) => {
      if (!LinkedPS.includes(item)) {
        let form = new FormData();
        form.append(
          "conditions",
          `product_service_id/=/${item.value}@@uid/=/${value.id}`
        );
        Delete_PServiceUserLink(form)
          .then((data) => {})
          .catch((error) => {
            console.log(error);
          });
      }
    });
    setPServices(LinkedPS);
  };
  useEffect(() => {
    if (type == 0) {
      let tags = [];
      value.linkedtag.forEach((element) => {
        if (
          tags.findIndex((value) => {
            return (
              value.value == element.tag__id && value.label == element.text
            );
          }) == -1
        ) {
          tags.push({
            value: `${element.tag__id}`,
            label: `${element.text}`,
          });
        }
      });
      setTags(tags);
    } else if (type == 1) {
      let Pservices = [];
      value.PServiceUserLink.forEach((element) => {
        if (
          Pservices.findIndex((value) => {
            return (
              value.value == element.product_service_id &&
              value.label == element.title
            );
          }) == -1
        ) {
          Pservices.push({
            value: `${element.product_service_id}`,
            label: `${element.title}`,
          });
        }
      });
      setPServices(Pservices);
    } else {
      let customers = [];
      value.CustomerUserLink.forEach((element) => {
        if (
          customers.findIndex((value) => {
            return (
              value.value == element.customer_id &&
              value.label == element.company_name
            );
          }) == -1
        ) {
          customers.push({
            value: `${element.customer_id}`,
            label: `${element.company_name}`,
          });
        }
      });
      setCustomers(customers);
    }
  }, [filteredUsers]);

  return (
    <>
      {type == 0 ? (
        <CreatableSelect
          isMulti
          placeholder={"انتخاب"}
          options={Labels}
          value={Tags}
          className="text-dark user-label"
          onChange={(e) => UsersTag(e)}
          isDisabled={disabled}
        />
      ) : type == 1 ? (
        <Select
          isMulti
          placeholder={"انتخاب"}
          options={Labels}
          value={PServices}
          className="text-dark user-label"
          onChange={(e) => UsersPS(e)}
          isDisabled={disabled}
        />
      ) : (
        <Select
          isMulti
          placeholder={"انتخاب"}
          options={Labels}
          value={Customers}
          className="text-dark user-label"
          onChange={(e) => UsersCustomers(e)}
          isDisabled={disabled}
        />
      )}
    </>
  );
}

export default function CustomerTab({
  setUpdaterModal,
  UpdaterModal,
  setId,
  Pages,
  Labels,
  PServices,
  Customers,
  deleteUser,
  changeStatus,
  filteredUsers,
  setSelectedUserInformation,
  chosenPeople,
  setChosenPeople,
  User_Access,
  CountCustomers,
  FilterKey,
  FilterSend,
  pagination,
  setpagination,
}) {
  const { userInfo } = useContext(AuthenticationContext);

  const date = (TimeStamp) => {
    if (!TimeStamp) {
      return "---";
    } else {
      let options = { year: "numeric", month: "numeric", day: "numeric" };
      let date = new Date(parseInt(TimeStamp) * 1000).toLocaleDateString(
        "fa-IR",
        options
      );
      date.replace(/([۰-۹])/g, (token) =>
        String.fromCharCode(token.charCodeAt(0) - 1728)
      );
      return date;
    }
  };

  function addChosen(id, email) {
    setChosenPeople((prev) => [...prev, [id, email]]);
  }

  function removeChosen(id) {
    setChosenPeople((prev) => prev.filter((value) => value[0] != id));
  }

  const Check = (chosenPeople, value) => {
    chosenPeople.map((item) => {
      if (+item[0] == +value.id) {
        return true;
      }
    });
    return false;
  };

  useEffect(() => {}, [filteredUsers.length]);
  var isGroupSelected = false;
  const multipleOperations = useRef(null);
  return (
    <>
      <div
        className="tab-pane fade  Tabs"
        id="customers"
        role="tabpanel"
        aria-labelledby="customers-tab"
      >
        <div className="row mx-auto">
          <div className="content p-1 mt-2 text-center  mx-auto multiple-operations">
            <div className="mx-auto">
              <span className="selected-number mx-1">
                {chosenPeople.length}
              </span>
              <span>کاربر انتخاب شده</span>
            </div>

            <button
              className="d-none"
              id="open-send-message-modal"
              data-bs-toggle="modal"
              data-bs-target="#send-message"
            ></button>

            <button
              className="d-none"
              id="open-toggle-status-modal"
              data-bs-toggle="modal"
              data-bs-target="#toggle-status-modal"
            ></button>

            <button
              className="d-none"
              id="open-change-label-modal"
              data-bs-toggle="modal"
              data-bs-target="#change-label"
            ></button>

            {userInfo.userRoll.includes(27) && (
              <div className="mx-auto text-center d-flex justify-content-center mt-3">
                <div style={{ width: "150px" }}>
                  <select
                    className="mx-auto form-select "
                    id=""
                    ref={multipleOperations}
                  >
                    <option value="" disabled hidden selected>
                      عملیات گروهی
                    </option>
                    <option value=""> برچسب</option>
                    <option value="">ارسال پیام</option>
                    <option value="">تغییر وضعیت</option>
                  </select>
                </div>
                <div className="text-center mx-2">
                  <button
                    className="btn btn-success "
                    onClick={() => {
                      isGroupSelected = true;
                      if (multipleOperations.current.selectedIndex == 1) {
                        document
                          .querySelector("#open-change-label-modal")
                          .click();
                      } else if (
                        multipleOperations.current.selectedIndex == 2
                      ) {
                        document
                          .querySelector("#open-send-message-modal")
                          .click();
                      } else if (
                        multipleOperations.current.selectedIndex == 3
                      ) {
                        document
                          .querySelector("#open-toggle-status-modal")
                          .click();
                      }
                    }}
                  >
                    اجرا
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        {filteredUsers &&
          filteredUsers.map((value, index) => {
            return (
              <TableBox
                Status={parseInt(value.main_status) != 2 ? true : false}
                TableInfo={[
                  [
                    "انتخاب",
                    <input
                      type="checkbox"
                      checked={Check(chosenPeople, value)}
                      className="mx-auto form-check-input"
                      onChange={(e) => {
                        if (e.target.checked) {
                          addChosen(value.id, value.email);
                        } else {
                          removeChosen(value.id, value.email);
                        }
                      }}
                    />,
                  ],
                  [
                    "نام و نام خانوادگی",
                    value.fname || value.lname
                      ? value.fname + " " + value.lname
                      : "---",
                  ],
                  ["شماره همراه", value.mobile ? value.mobile : "---"],
                  [
                    "وضعیت",
                    parseInt(value.main_status) != 2
                      ? parseInt(value.main_status) == 0
                        ? "فعال"
                        : "فعال (رفع مسدودی)"
                      : "غیر فعال",
                  ],
                  ["کد ملی", value.codemeli ? value.codemeli : "---"],
                  ["تاریخ وضعیت", date(value.mtm)],
                  [
                    "برچسب",
                    <Selector
                      value={value}
                      type={0}
                      Labels={Labels}
                      filteredUsers={filteredUsers}
                      disabled={!userInfo.userRoll.includes(28)}
                    />,
                  ],
                  [
                    "تسک ها",
                    <Selector
                      value={value}
                      type={1}
                      Labels={PServices}
                      filteredUsers={filteredUsers}
                      disabled={!userInfo.userRoll.includes(29)}
                    />,
                  ],

                  [
                    "مشتریان",
                    <Selector
                      value={value}
                      type={2}
                      Labels={Customers}
                      filteredUsers={filteredUsers}
                      disabled={!userInfo.userRoll.includes(30)}
                    />,
                  ],
                  [
                    "عملیات",
                    <div className="d-flex justify-content-center">
                      {userInfo.userRoll.includes(31) && (
                        <CustomTooltip
                          title="ویرایش"
                          placement="top"
                          color="secondary_custom"
                        >
                          <div
                            onClick={() => {
                              setSelectedUserInformation(value);
                            }}
                            data-bs-toggle="modal"
                            data-bs-target="#edit-user"
                          >
                            <EditIcon
                              style={{ cursor: "pointer" }}
                              containerIconClassName="mx-auto"
                              width="80%"
                              color={ColorSchema.white_custom}
                            ></EditIcon>
                          </div>
                        </CustomTooltip>
                      )}
                      {userInfo.userRoll.includes(32) && (
                        <CustomTooltip
                          title="تغییر وضعیت"
                          placement="top"
                          color="secondary_custom"
                        >
                          <div
                            onClick={() => {
                              return changeStatus(
                                [parseInt(value.id)],
                                parseInt(value.main_status) != 2 ? 2 : 1,
                                0
                              );
                            }}
                          >
                            {parseInt(value.main_status) != 2 ? (
                              <StopIcon
                                style={{ cursor: "pointer" }}
                                containerIconClassName="mx-auto"
                                width="80%"
                                color={ColorSchema.white_custom}
                              ></StopIcon>
                            ) : (
                              <TickIcon
                                style={{ cursor: "pointer" }}
                                containerIconClassName="mx-auto"
                                width="100%"
                                color={ColorSchema.white_custom}
                              ></TickIcon>
                            )}
                          </div>
                        </CustomTooltip>
                      )}

                      {/* <NavLink
                        target="_blank"
                        to={`/admin-panel/user-report/${value.id}`}
                        style={{ color: "white", textDecoration: "normal" }}
                      >
                        <RiFilePaperLine
                          className="mx-1"
                          data-tip="گزارش"
                        ></RiFilePaperLine>
                      </NavLink> */}

                      {/* <AiOutlineDelete
                        className="mx-1 tab-pane-hover"
                        onClick={() => {
                          return deleteUser(parseInt(value.id));
                        }}
                        data-tip="حذف"
                      ></AiOutlineDelete> */}
                      {userInfo.userRoll.includes(33) && (
                        <CustomTooltip
                          title="سطح دسترسی"
                          placement="top"
                          color="secondary_custom"
                        >
                          <div
                            data-bs-toggle="modal"
                            data-bs-target="#access-level"
                            onClick={() => {
                              User_Access(value.id);
                              setSelectedUserInformation(value);
                            }}
                          >
                            <LockIcon
                              style={{ cursor: "pointer" }}
                              containerIconClassName="mx-auto"
                              width="70%"
                              color={ColorSchema.white_custom}
                            ></LockIcon>
                          </div>
                        </CustomTooltip>
                      )}

                      {userInfo.userRoll.includes(34) && (
                        <CustomTooltip
                          title="ارسال پیام"
                          placement="top"
                          color="secondary_custom"
                        >
                          <div
                            data-bs-toggle="modal"
                            data-bs-target="#send-message"
                            onClick={() => {
                              setSelectedUserInformation(value);
                            }}
                          >
                            <TelegramIcon
                              style={{ cursor: "pointer" }}
                              containerIconClassName="mx-auto"
                              width="70%"
                              color={ColorSchema.white_custom}
                            ></TelegramIcon>
                          </div>
                        </CustomTooltip>
                      )}
                    </div>,
                  ],
                ]}
              />
            );
          })}

        <ReactPaginate
          forcePage={pagination}
          previousLabel={"قبلی"}
          nextLabel={"بعدی"}
          breakLabel={"..."}
          breakClassName={"break-me"}
          pageCount={Math.ceil(CountCustomers / 10)}
          marginPagesDisplayed={2}
          pageRangeDisplayed={2}
          onPageChange={(e) => {
            !FilterKey ? Pages(e.selected, 2) : FilterSend(2, e.selected + 1);
            setpagination(e.selected);
          }}
          containerClassName="pagination mx-auto mb-3"
          activeLinkClassName="text-white"
          activeClassName="bg-info style-activeClass"
          pageClassName="style-pageClass mx-2 border border-1"
          pageLinkClassName="page-link style-page-link"
          nextClassName="border btn mx-1 px-4 py-1 style-nextClass"
          previousClassName="border btn mx-1 px-4 py-1 style-previousClass "
          nextLinkClassName="style-nextLink "
          previousLinkClassName="style-previousLink "
        />
      </div>
    </>
  );
}
